import IPlanTemplateInput from './IPlanTemplateInput';
import IFileUploads from './IFileUploads';
import IPlanTemplate from './IPlanTemplate';
import Api from '../../shared/Api';

class PlanTemplatesApi {
    static create(input: IPlanTemplateInput, fileuploads: IFileUploads): Promise<IPlanTemplate> {
        return new Promise<any>(
            (resolve: (result: IPlanTemplate) => void, reject: (errors: string[]) => void) => {
                let addedTemplate: IPlanTemplate;
                new Api()
                    .post('/views/plantemplates', input)
                    .then((template: any) => {
                        addedTemplate = template;
                        return new Api()
                            .postFiles(
                                `/views/plantemplates/${template.id}/files`,
                                fileuploads.files
                            )
                            .then((fileReferences: any) => {
                                addedTemplate.imageReferences = fileReferences;
                                return template;
                            });
                    })
                    .then(resolve)
                    .catch((error: any) => {
                        if (addedTemplate) {
                            resolve(addedTemplate);
                        }
                        reject(error);
                        throw error;
                    });
            }
        );
    }

    static list(): any {
        return new Api().get('/views/plantemplates');
    }

    static uploadFiles(id: number, fileuploads: IFileUploads): Promise<string> {
        return new Promise<any>(
            (resolve: (result: string) => void, reject: (errors: string[]) => void) => {
                return new Api()
                    .postFiles(`/views/plantemplates/${id}/files`, fileuploads.files)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static delete(id: number): any {
        return new Promise<any>(
            (resolve: (result: IPlanTemplate) => void, reject: (error: any) => void) => {
                new Api()
                    .delete(`/views/plantemplates/${id}`)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static update(
        planTemplate: IPlanTemplateInput,
        fileuploads: IFileUploads,
        id: number
    ): Promise<IPlanTemplate> {
        return new Promise<any>(
            (resolve: (result: IPlanTemplate) => void, reject: (errors: string[]) => void) => {
                let updatedTemplate: IPlanTemplate;
                new Api()
                    .put(`/views/plantemplates/${id}`, planTemplate)
                    .then((template: any) => {
                        updatedTemplate = template;
                        if (fileuploads.files.length !== 0) {
                            return new Api()
                                .postFiles(
                                    `/views/plantemplates/${template.id}/files`,
                                    fileuploads.files
                                )
                                .then((fileReferences: any) => {
                                    updatedTemplate.imageReferences = fileReferences;
                                    return template;
                                });
                        }
                        return template;
                    })
                    .then(resolve)
                    .catch((error: any) => {
                        if (updatedTemplate) {
                            resolve(updatedTemplate);
                        }
                        reject(error);
                        throw error;
                    });
            }
        );
    }
}

export default PlanTemplatesApi;
